<script setup lang="ts">
/**
 * Contenu du toast « en direct » (`useToastEnDirect`, Karim 2026-10-13) : la
 * mascotte Donoor qui lance des cœurs (la même que le « Coup de cœur
 * Donoor »), la phrase en gras, et le moment précédé d'un point vert qui
 * pulse — l'impression qu'un don vient d'arriver.
 */
import MascotteCoeurs from "~/components/shared/MascotteCoeurs.vue";

defineProps<{ titre: string; quand: string }>();
</script>

<template>
  <div class="flex items-center gap-3.5">
    <MascotteCoeurs :taille="46" />
    <div class="min-w-0">
      <p class="text-[15px] leading-snug text-(--color-ink)" style="font-weight: 700 !important">{{ titre }}</p>
      <p class="mt-0.5 flex items-center gap-1.5 text-[13px] text-gray-500">
        <span class="point-direct size-[7px] shrink-0 rounded-full bg-[#22c55e]" />
        {{ quand }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.point-direct {
  animation: point-direct 1.8s ease-out infinite;
}
@keyframes point-direct {
  0% {
    box-shadow: 0 0 0 0 rgb(34 197 94 / 0.55);
  }
  70%,
  100% {
    box-shadow: 0 0 0 6px rgb(34 197 94 / 0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .point-direct {
    animation: none;
  }
}
</style>
